import React from 'react';

const Loading = () => {
    return (
        <div className='flex justify-center items-center h-screen'>
            <button className="btn btn-square loading"></button>
        </div>
    );
};

export default Loading;